
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    getSignInList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/SignIn/Index',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    SignInPost({commit},payload)
    {
        return new Promise((resolve,reject) => {
            api.post('/SignIn/Post',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    }
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
